export const ActionTypes = {
  LOADING: "CREATE_ACTION_LOADING",
  ERROR: "CREATE_ACTION_ERROR",
  SUCCESS: "CREATE_ACTION_SUCCESS",
};
